export default __webpack_public_path__ + "static/media/a012-market-line-6.b88da0f4.svg";